<template>
<div>
  <div class="tw-py-4 tw-px-0 md:tw-p-8 tw-mb-[85px]">
    <div class="tw-flex tw-gap-4 md:tw-gap-8 md:tw-pr-7 !tw-mb-5 tw-pl-2">
      <div class="form-check form-check-inline tw-select-none tw-m-0">
        <input class="form-check-input" v-model="active_page" type="radio" name="exampleRadios" id="exampleRadios1" value="new_card">
        <label class="form-check-label" for="exampleRadios1" :class="[
        active_page !== 'new_card' && 'tw-cursor-pointer'
      ]">
          سفارش جدید
        </label>
      </div>
      <div class="form-check form-check-inline tw-select-none !tw-m-0 tw-pl-2">
        <input class="form-check-input tw-cursor-pointer" v-model="active_page" type="radio" name="exampleRadios" id="exampleRadios2" value="warehouse_transfer">
        <label class="form-check-label" for="exampleRadios2" :class="[
        active_page !== 'warehouse_transfer' && 'tw-cursor-pointer'
      ]">
          حواله نبار
        </label>
      </div>
      <div class="form-check form-check-inline tw-select-none !tw-m-0 tw-pl-2">
        <input class="form-check-input tw-cursor-pointer" v-model="active_page" type="radio" name="exampleRadios" id="exampleRadios3" value="sale_invoice">
        <label class="form-check-label" for="exampleRadios3" :class="[
        active_page !== 'sale_invoice' && 'tw-cursor-pointer'
      ]">
          فاکتور فروش
        </label>
      </div>
    </div>

    <transition name="slide-fade" mode="out-in">
      <div :key="active_page" class="tab-body">

        <form-new-order v-if="active_page === 'new_card'"
                        :data-store-order="dataStoreOrder"
                        :get-data-loading="getDataStoreOrderLoading"/>

        <form-new-warehouse-transfer v-else-if="active_page === 'warehouse_transfer'"
                                     :data-store-order="dataStoreOrder"
                                     :get-data-loading="getDataStoreOrderLoading" />

        <form-new-sale-invoice v-else-if="active_page === 'sale_invoice'"
                               :data-store-order="dataStoreOrder"
                               :get-data-loading="getDataStoreOrderLoading" />
      </div>
    </transition>
  </div>
</div>
</template>

<script setup>

import {onMounted, ref} from 'vue';
import FormNewOrder from "@/components/orders/FormNewOrder.vue";
import FormNewWarehouseTransfer from "@/components/orders/FormNewWarehouseTransfer.vue";
import {apiGetDataStoreOrder} from "@/services/orders/Orders";
import FormNewSaleInvoice from "@/components/orders/FormNewSaleInvoice.vue";

const active_page = ref('sale_invoice');
const getDataStoreOrderLoading = ref(false)
const dataStoreOrder = ref(() => {})
const direction = ref('forward')

onMounted(() => {
  getDataStoreOrder()
})

async function getDataStoreOrder() {
  getDataStoreOrderLoading.value = true

  try {
    const response = await apiGetDataStoreOrder()
    if(!response) return

    dataStoreOrder.value = response.data

  } catch (e) {
    console.log(e)
  } finally {
    getDataStoreOrderLoading.value = false
  }
}
</script>

<style scoped>
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.35s ease;
}

.slide-fade-enter-from {
  opacity: 0;
  transform: translateX(40px);
}

.slide-fade-leave-to {
  opacity: 0;
  transform: translateX(-40px);
}
</style>
